import { PostHogProvider as LibPosthogProvider } from "posthog-js/react";
import { posthogClient } from "~/shared/lib/posthog/posthog-client";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!posthogClient) return <>{children}</>;
  return <LibPosthogProvider client={posthogClient}>{children}</LibPosthogProvider>;
}
